import { GROUPSTAB, USERSTAB } from "../constant/tabTitle";

export const getFilter = ({ key, configSlice }) => {
  const statusOptions = [
    { value: "active", name: "Active", key: true, type: "status" },
    { value: "inactive", name: "Inactive", key: false, type: "status" },
  ];
  const mapRoles = (roles) => roles.map(({ id, name }) => ({ value: id, name, key: name, type: "role" }));

  switch (key) {
    case GROUPSTAB: {
      return [
        {
          name: "Status",
          tags: statusOptions,
        },
        {
          name: "Group types",
          tags: mapRoles(configSlice.groupTypes),
        },
      ];
    }
    case USERSTAB: {
      return [
        {
          name: "Status",
          tags: statusOptions,
        },
        {
          name: "Roles",
          tags: mapRoles(configSlice.roles),
        },
      ];
    }
  }
};
